import { isEmpty, xorWith, isEqual } from 'lodash';

export const unique = (arr) =>
  arr.filter((elem, idx) => arr.indexOf(elem) === idx);

export const areArraysEqual = (x, y) => {
  return isEmpty(xorWith(x, y, isEqual));
};
